import { toast as sonnerToast } from "sonner";
import { ToastProps } from "./toast-types";

// Simplified toast adapter using Sonner directly
export const toast = (props: ToastProps | string) => {
  // Handle string shorthand
  if (typeof props === 'string') {
    return sonnerToast.success(props);
  }
  
  // Handle object with variant
  if (props.variant === 'destructive') {
    return sonnerToast.error(props.title || 'Error', {
      description: props.description
    });
  }
  
  // Default to success for positive actions
  return sonnerToast.success(props.title || 'Éxito', {
    description: props.description
  });
};

// Keep utility methods
toast.success = (message: string, options?: any) => {
  return sonnerToast.success(message, options);
};

toast.error = (message: string, options?: any) => {
  return sonnerToast.error(message, options);
};

toast.warning = (message: string, options?: any) => {
  return sonnerToast.warning(message, options);
};

toast.info = (message: string, options?: any) => {
  return sonnerToast.info(message, options);
};

toast.loading = (message: string, options?: any) => {
  return sonnerToast.loading(message, options);
};

toast.dismiss = (toastId?: string) => {
  if (toastId) {
    return sonnerToast.dismiss(toastId);
  }
  return sonnerToast.dismiss();
};
